export default {"src":"/_next/static/media/CUBE.581506bb.svg","height":18,"width":18};